export default "__VITE_ASSET__Cb0Yifvv__$_?url__"